<template>
  <div class="region-select-dia">
    <common-dialog :title="title" ref="dialog" width="350px" @confirm="confirm">
      <div>
        <el-select v-model="region" placeholder="请选择">
          <el-option
            v-for="(item,index) in data"
            :key="index"
            :label="item[props.label]"
            :value="item[props.value]">
          </el-option>
        </el-select>
      </div>
    </common-dialog>
  </div>
</template>
<script>
import CommonDialog from './CommonDialog'
export default {
  name:"RegionSelectDia",
  components:{
    CommonDialog
  },
  props:{
    mode:{
      type:Number,
      default:()=>1
    },
    data:{
      type:Array,
      default:()=>[]
    },
    title:{
      type:String,
      default:()=>"提示"
    },
    placeholder:{
      type:String,
      default:()=>"请选择区域"
    },
    props:{
      type:Object,
      default:()=>({
        label:"name",
        value:"code"
      })
    }
  },
  data(){
    return {
      region:""
    }
  },
  methods:{
    show(){
      this.$refs.dialog.show()
      this.region = ""
    },
    hiden(){
      this.$refs.dialog.hiden()
    },
    confirm(){
      if(this.mode==1){
        this.$emit("switchRegion",this.region)
        console.log(this.mode,'switchRegion',this.region)
      }else{
        this.$emit("switchStation",this.region)
        console.log(this.mode,'switchStation',this.region)
      }
      this.hiden()
    }
  },
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/RegionSelectDia.vue